import Vue from 'vue'

Vue.component('BreadCrumbs', () =>
  import('./components/header/BreadCrumbs.vue')
)
